
import { Component, Mixins } from "vue-property-decorator";
import { ICalculationExpressionBehavior } from "../../../../../../documaker/domain/format/objects";
import { ICalculationExpressionBehaviorPropertyEditable, instanceOfICalculationExpressionBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class CalculationExpressionBehaviorPropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: ICalculationExpressionBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICalculationExpressionBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isCalculationExpressionBehaviorPropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfICalculationExpressionBehaviorPropertyEditable(s) && s.calculationExpressionBehavior().isEditable(), false);
  }

  get calculationExpressionBehavior(): ICalculationExpressionBehavior {
    return this.readPropertyOrDefault(s => s.calculationExpressionBehavior().getValue(), { contents: [], conditionalExpressionBehavior: { contents: [] } });
  }

  set calculationExpressionBehavior(value: ICalculationExpressionBehavior) {
    this.writePropertyWhenValid(s => s.calculationExpressionBehavior().setValue(value));
  }
}
